import axiosInstance from "./axiosInstance";

const verifyUser = async ({email, pin}: {email: string; pin: string}) => {
  try {
    const {data} = await axiosInstance.post("/verifyUser", {email, pin});
    return data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Failed to check email. Please try again.");
  }
};

export default verifyUser;
